.hover {
  cursor: pointer;
  border-radius: 0.25rem;
  padding: 0.125rem 0.375rem;
  display: block;

  &:hover {
    background-color: var(--bs-primary-bg-subtle);
  }

  &:focus {
    outline: 1px solid var(--bs-link-color);
    outline-offset: 1px;
  }
}
